// Only an explicit true enables Oasys SSO. Legacy HRMS login is the default.
export const isOasysSsoEnabled = (): boolean =>
    import.meta.env.VITE_OASYSSSO_ENABLED === 'true'
